/**
 * Port von `Pages/Index.razor`, seit REQ-22 im Look des Entwurfs
 * „IWM Hub Redesign" (Zeilen 473–600): Begrüßung mit Datum, darunter je
 * Kategorie ein Abschnitt mit den Ansichtskarten.
 */

import { Fragment, type ReactElement } from 'react';

import { useAuth } from '@/auth/useAuth';
import { DashboardNavCard } from '@/components/layout/DashboardNavCard';
import { useMyCategories } from '@/hooks/useMyCategories';

/** „Donnerstag, 30. Juli 2026" — ausgeschrieben wie im Entwurf. */
const DATE_FORMAT = new Intl.DateTimeFormat('de-DE', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

/**
 * Begrüßung des Entwurfs. Der Vorname ist das erste Wort aus `user.Name`; lässt
 * sich keiner ermitteln, wird der vollständige Name verwendet (REQ-22 §2.1).
 */
function greeting(name: string | null | undefined): string {
  const full = name?.trim() ?? '';
  if (full === '') return 'Guten Tag';
  const [first = full] = full.split(/\s+/);
  return `Guten Tag, ${first}`;
}

export function Dashboard(): ReactElement {
  const { user } = useAuth();
  const { categories } = useMyCategories();

  return (
    <main className="iwm-dashboard">
      <h1>{greeting(user?.Name)}</h1>
      <div className="iwm-dashboard-sub">{DATE_FORMAT.format(new Date())}</div>

      {categories.map((category) => {
        const views = category.Views ?? [];
        // Kategorien ohne Ansicht blieben schon vor REQ-22 unsichtbar; ein
        // leerer Abschnittstitel mit Linie wäre nur Rauschen.
        if (views.length === 0) return null;

        return (
          <Fragment key={category.Id}>
            <div className="iwm-dashboard-section-head">
              <span>{category.Bezeichnung}</span>
              <span className="iwm-dashboard-rule" />
            </div>
            <div className="iwm-dashboard-grid">
              {views.map((view) => (
                <DashboardNavCard key={view.Id} view={view} kategorie={category.Bezeichnung} />
              ))}
            </div>
          </Fragment>
        );
      })}
    </main>
  );
}

export default Dashboard;
